import React, { useState, useEffect } from "react";
import { Drawer, Form, Checkbox, Icon, Upload, notification, DatePicker, InputNumber } from "antd";
import { Redirect, useLocation } from "react-router-dom";
import axios from "axios";
import moment from "moment";

import ModalAlertaMatricula from "../Modals/ModalAlertaMatricula";

const Dragger = Upload.Dragger;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const DrawerTransferenciaListaDisciplinas = ({
    visible,
    cursos,
    utilizador,
    utilizadores,
    onClose,
    onConfirm,
    onConfirmImport,
    importacao,
    turmaId,
    form
}) => {
    const [listaDisciplinas, setListaDisciplinas] = useState([]);
    const [quantitativos, setQuantitativos] = useState([]);
    const [selecionados, setSelecionados] = useState([]);
    const [indeterminate, setIndeterminate] = useState(false);
    const [todos, setTodos] = useState(true);
    const [data, setData] = useState(moment());
    const [assiduidade, setAssiduidade] = useState("");
    const [ordem, setOrdem] = useState(1);
    const [fileList, setFileList] = useState([]);
    const [iconLoading, setIconLoading] = useState(false);

    const [modalVisible, setModalVisible] = useState(false);
    const [alerta, setAlerta] = useState(null);
    const [tipoInserirNotas, setTipoInserirNotas] = useState("");
    const [redirect, setRedirect] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");

    const location = useLocation();

    const { getFieldDecorator } = form;

    const onChange = selecionados => {
        form.resetFields();
        setSelecionados(selecionados);
        setIndeterminate(!!selecionados.length && selecionados.length < listaDisciplinas?.filter(d => d.visivel).length);
        setTodos(selecionados.length === listaDisciplinas?.filter(d => d.visivel).length);
    };

    const handleChange = date => {
        setData(date);
    };

    const handleChangeQuantitativo = (quantitativo, index) => {
        var _quantitativos = quantitativos;

        _quantitativos[index].quantitativo = quantitativo;

        setQuantitativos([..._quantitativos]);
    };

    const handleChangeOrdem = ordem => {
        setOrdem(ordem);
    };

    const selecionarTodos = event => {
        form.resetFields();
        setSelecionados(event.target.checked ? listaDisciplinas.map(item => item.id) : []);
        setIndeterminate(false);
        setTodos(event.target.checked);
    };

    const confirma = () => {
        form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                setIconLoading(true);

                if (localStorage.getItem("tipo_turma") === "ENSINO_ESPECIAL") {
                    guardarInscricao();
                } else {
                    if (!importacao) avaliarMatriculaAluno();
                    else guardarInscricaoPorImportacao();
                }
            }
        });
    };

    const avaliarMatriculaAluno = () => {
        axios({
            method: "post",
            url: "/api/gestao-turma-matriculas/obter-alerta-matricula",
            data: {
                turmaId: localStorage.getItem("codigo_curso"),
                utilizadorId: utilizador.id,
                dataMatricula: moment(data).format("YYYY-MM-DD")
            }
        })
            .then(response => {
                if (localStorage.getItem("entidade_id") !== "33") {
                    guardarInscricao();
                } else {
                    const alerta = response.data.data;

                    if (alerta.tipo === 0) guardarInscricao();
                    else {
                        setAlerta(alerta);
                        setModalVisible(true);
                    }
                }
            })
            .catch(error => {
                setIconLoading(false);
                openNotificationWithIcon("error", "Erro", error.response.data);
            });
    };

    const guardarInscricao = () => {
        setTipoInserirNotas("");
        form.validateFieldsAndScroll((err, values) => {
            if (err) return null;
        });

        var item = new FormData();
        item.append("cursoId", localStorage.getItem("codigo_curso"));
        if (alerta?.turmaId) item.append("turmaOrigemId", alerta?.turmaId);
        item.append("utilizadorId", utilizador.id);
        item.append("selecionados", JSON.stringify(selecionados));
        item.append("quantitativos", JSON.stringify(quantitativos));
        item.append("data", moment(data).format("YYYY-MM-DD"));
        item.append("assiduidade", assiduidade);
        item.append("ordem", ordem);
        if (fileList.length) item.append("anexo", fileList[0]);

        axios({
            method: "post",
            url: "/api/gestao-turma-matriculas/inscricoes",
            data: item
        })
            .then(() => {
                onConfirm(selecionados);
                setIconLoading(false);

                openNotificationWithIcon(
                    "success",
                    "Sucesso",
                    localStorage.getItem("tipo_turma") === "ENSINO_ESPECIAL"
                        ? "Aluno matrículado!"
                        : "Aluno matrículado nas disciplinas selecionadas!"
                );

                if (tipoInserirNotas === "importar") {
                    sessionStorage.setItem("alunoId", utilizador.id);
                    sessionStorage.setItem("turmaOrigemId", alerta?.turmaId);
                    sessionStorage.setItem("turmaDestinoId", localStorage.getItem("codigo_curso"));
                    sessionStorage.setItem("backUrl", location.pathname);

                    setRedirectLink("/transferencias/importar-notas");
                    setRedirect(true);
                }

                if (tipoInserirNotas === "manual") {
                    sessionStorage.setItem("alunoId", utilizador.id);
                    sessionStorage.setItem("turmaDestinoId", localStorage.getItem("codigo_curso"));
                    sessionStorage.setItem("backUrl", location.pathname);

                    setRedirectLink("/inserir-notas-manualmente");
                    setRedirect(true);
                }
            })
            .catch(error => {
                setIconLoading(false);
                openNotificationWithIcon("error", "Erro", error.response.data);
            });
    };

    const guardarInscricaoPorImportacao = () => {
        var item = new FormData();
        item.append("cursoId", localStorage.getItem("codigo_curso"));
        item.append("utilizadores", JSON.stringify(utilizadores.map(x => x.id)));
        item.append("selecionados", JSON.stringify(selecionados));
        item.append("data", moment(data).format("YYYY-MM-DD"));
        item.append("assiduidade", assiduidade);
        item.append("ordem", ordem);
        if (turmaId) item.append("turmaId", turmaId);
        // if (transferencia)
        //     item.append("transferencia", true);

        axios({
            method: "post",
            url: "/api/gestao-turma-matriculas/inscricoes-importar",
            data: item
        })
            .then(() => {
                onConfirmImport();
                setIconLoading(false);

                openNotificationWithIcon(
                    "success",
                    "Sucesso",
                    utilizadores.length > 1
                        ? "Alunos matrículados nas disciplinas selecionadas!"
                        : "Aluno matrículado nas disciplinas selecionadas!"
                );
            })
            .catch(error => {
                setIconLoading(false);
                openNotificationWithIcon("error", "Erro", error.response.data);
            });
    };

    const afterVisibleChange = visible => {
        if (visible) {
            form.resetFields();

            if (!importacao) {
                const inscricoes = utilizador.inscricoesDisciplina?.map(x => x.id);

                setData(moment());
                setAssiduidade("");
                setOrdem(1);

                if (inscricoes?.length > 0) {
                    setSelecionados(inscricoes);
                    setIndeterminate(!!inscricoes?.length && inscricoes?.length < listaDisciplinas.length);
                    setTodos(inscricoes?.length === listaDisciplinas.length);
                } else {
                    var ids = cursos.map(c => c.id);

                    setSelecionados(ids);
                    setIndeterminate(false);
                    setTodos(true);
                }
            } else {
                var ids = cursos.map(c => c.id);

                setData(moment());
                setAssiduidade("");
                setOrdem(1);
                setSelecionados(ids);
                setIndeterminate(false);
                setTodos(true);
            }
        }
    };

    const onCloseModal = tipo => {
        setTipoInserirNotas(tipo);
        setModalVisible(false);
    };

    useEffect(() => {
        setListaDisciplinas(cursos);
    }, [cursos]);

    useEffect(() => {
        if (selecionados.length > 0) {
            // mapeia os selecionados para objetos disciplina
            const novosQuantitativos = selecionados.map(idSel => {
                const curso = listaDisciplinas.find(d => d.id === idSel);
                return {
                    id: curso.id,
                    nome: curso.nome,
                    quantitativos: 0
                };
            });

            setQuantitativos(novosQuantitativos);
        } else {
            // se não houver nada selecionado, limpa
            setQuantitativos([]);
        }
    }, [selecionados]);

    useEffect(() => {
        if (tipoInserirNotas !== "") guardarInscricao();
    }, [tipoInserirNotas]);

    if (redirect) return <Redirect to={redirectLink} />;

    return (
        <>
            <Drawer
                className="drawer-inscrever"
                //title="Informações da transferência"
                width={720}
                onClose={onClose}
                visible={visible}
                style={{
                    overflow: "auto",
                    height: "calc(100% - 108px)",
                    paddingBottom: "108px"
                }}
                maskClosable={false}
                afterVisibleChange={afterVisibleChange}
            >
                <div className="bloco-drawer-associar">
                    <Form className="form-emitir-declaracao">
                        <Form.Item label="Data">
                            {getFieldDecorator("data", {
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ],
                                initialValue: data
                            })(
                                <DatePicker
                                    name="data"
                                    format="DD-MM-YYYY"
                                    placeholder="Selecionar"
                                    suffixIcon={false}
                                    clearIcon={false}
                                    onChange={handleChange}
                                />
                            )}
                        </Form.Item>
                        <Form.Item label="Assiduidade (%)">
                            {getFieldDecorator("assiduidade", {
                                initialValue: assiduidade
                            })(<InputNumber name="assiduidade" onChange={assiduidade => setAssiduidade(assiduidade)} />)}
                        </Form.Item>
                        <Form.Item label="Ordem">
                            {getFieldDecorator("ordem", {
                                initialValue: ordem,
                                rules: [
                                    {
                                        required: true,
                                        message: "Campo obrigatório"
                                    }
                                ]
                            })(<InputNumber placeholder="Ordem" min={1} onChange={handleChangeOrdem} />)}
                        </Form.Item>
                        <Form.Item label={localStorage.getItem("tipo_turma") === "ENSINO_ESPECIAL" ? "Disciplinas" : "Acompanhamentos"}>
                            <div style={{ marginBottom: "20px" }}>
                                <Checkbox indeterminate={indeterminate} onChange={selecionarTodos} checked={todos}>
                                    Todas
                                </Checkbox>
                            </div>
                            {getFieldDecorator("disciplinasSelecionadas", {
                                rules: [{ required: true, message: "Por favor, selecione ao menos uma disciplina!" }],
                                initialValue: selecionados
                            })(
                                <Checkbox.Group style={{ width: "100%" }} onChange={onChange}>
                                    {listaDisciplinas
                                        .filter(d => d.visivel)
                                        .map((disciplina, index) => (
                                            <div key={disciplina.id} style={{ marginBottom: "20px" }}>
                                                <Checkbox value={disciplina.id}>{disciplina.nome}</Checkbox>
                                            </div>
                                        ))}
                                </Checkbox.Group>
                            )}
                        </Form.Item>
                        {quantitativos.length > 0 && localStorage.getItem("entidade_id") === "33" && (
                            <div>
                                <h3 className="titulo-separador">Quantitativos por disciplina</h3>
                                <p>Indique o número de faltas registadas em cada disciplina.</p>
                                {quantitativos.map((disciplina, index) => (
                                    <Form.Item label={disciplina.nome}>
                                        {getFieldDecorator(`quantitativo${index}`, {
                                            initialValue: disciplina.quantitativo
                                        })(<InputNumber min={0} onChange={value => handleChangeQuantitativo(value, index)} />)}
                                    </Form.Item>
                                ))}
                            </div>
                        )}
                    </Form>
                </div>
                <div className="ant-drawer-footer">
                    <button className="botao-secundario" onClick={onClose} style={{ marginRight: 20, display: "inline-block" }}>
                        Voltar
                    </button>
                    <button className="botao-principal" type="primary" disabled={iconLoading} onClick={confirma}>
                        {iconLoading ? <Icon type="loading" /> : null}
                        Salvar
                    </button>
                </div>
            </Drawer>
            <ModalAlertaMatricula
                visible={modalVisible}
                tipo={alerta?.tipo}
                turma={alerta?.turma}
                escola={alerta?.escola}
                onClose={onCloseModal}
            />
        </>
    );
};

const FormDrawerTransferenciaListaDisciplinas = Form.create({ name: "drawer-transferencia-lista-disciplinas" })(
    DrawerTransferenciaListaDisciplinas
);

export default FormDrawerTransferenciaListaDisciplinas;
